import { useState } from "react"
import { Bell, ChevronDown, Menu, X } from "lucide-react"
import Button from "./ButtonComponent"
import { Link } from "react-router-dom"

interface NavbarProps {
  isLoggedIn?: boolean
  userName?: string
  onLogout?: () => void
}

export default function Navbar({ isLoggedIn = true, userName = "Dr. Gupta", onLogout }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)

  return (
    <nav className="bg-white  border-b border-gray-200 sticky top-0 z-20">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo Section */}
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <img src="/images/heart-logo.png" alt="Helius Logo" className="w-8 h-8" />
            <img src="/images/helius-text.png" alt="Helius" className="w-[85.33px] h-[16px]" />
          </Link>

          {/* Desktop Right Section */}
          <div className="hidden md:flex items-center space-x-4">
            {isLoggedIn ? (
              <>
                {/* Notification Bell */}
                <Button className="!p-2 !px-2 !py-2 hidden">
                  <Bell className="h-5 w-5" />
                </Button>

                {/* User Menu */}
                <div className="relative">
                    <Button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}>
                    <span className="text-sm font-medium">{userName}</span>
                    <ChevronDown className="h-4 w-4" />
                    </Button>

                  {/* Dropdown Menu */}
                  {isUserMenuOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-10">
                      <button 
                        onClick={() => {
                          onLogout?.();
                          setIsUserMenuOpen(false);
                        }}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                      >
                        Log out
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <Button>Sign In</Button>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg"
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            {isLoggedIn ? (
              <div className="space-y-3">
                <div className="flex items-center justify-between px-4 py-2">
                  <span className="text-sm font-medium text-gray-700">{userName}</span>
                  <Button className="!p-2 !px-2 !py-2">
                    <Bell className="h-5 w-5" />
                  </Button>
                </div>
                <div className="border-t border-gray-200 pt-3 space-y-1">
                  <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
                    Profile
                  </a>
                  <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
                    Settings
                  </a>
                  <button 
                    onClick={() => {
                      onLogout?.();
                      setIsMobileMenuOpen(false);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    Sign out
                  </button>
                </div>
              </div>
            ) : (
              <div className="px-4">
                <Button className="w-full">Sign In</Button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Overlay for dropdown */}
      {isUserMenuOpen && <div className="fixed inset-0 z-0" onClick={() => setIsUserMenuOpen(false)} />}
    </nav>
  )
}
